import { render, staticRenderFns } from "./WorkbookPreview.vue?vue&type=template&id=5f3d33e6"
import script from "./WorkbookPreview.vue?vue&type=script&lang=js"
export * from "./WorkbookPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports